export default __webpack_public_path__ + "static/clientwork2-1fbcc760acba2584a865cf7956d30a77.png";